import FormHelperText from '@mui/material/FormHelperText'
import Stack from '@mui/material/Stack'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useTranslation } from 'react-i18next'
import upperFirst from 'lodash/upperFirst'
import { isSameDay } from 'date-fns/isSameDay'

import { formatHumanDateTime, formatHumanTime } from '../../../../utils'
import { LoaderData, ParticipantStatus, OptionPathKeys } from '../../../../types'
import type { eventRegistrationDetailsLoader } from '../RegisterEvents.loader'
import { RegistrationOptions } from './filterRegistrationOptions'

interface Props {
  path: OptionPathKeys
  elem: RegistrationOptions
  setOptionsByType: (path: OptionPathKeys, value: string, elem: RegistrationOptions) => void
  registrationDetails: LoaderData<ReturnType<typeof eventRegistrationDetailsLoader>>
  hideFreePrice?: boolean
}

export default function CheckBoxLine({
  elem,
  setOptionsByType,
  registrationDetails,
  path,
  hideFreePrice = false,
}: Props) {
  const { t } = useTranslation()

  const sameDay = isSameDay(elem.start, elem.end)
  let label: React.ReactNode = ''
  if (path === 'checkboxOptions' || path === 'hotelOptions') {
    label = <strong>{elem.option.name}</strong>
  } else {
    label = (
      <>
        <strong>{elem.option.name}</strong>
        {` : ${upperFirst(formatHumanDateTime(elem.start))} - ${sameDay ? formatHumanTime(elem.end) : formatHumanDateTime(elem.end, true)}`}
      </>
    )
  }
  const price = Number(elem.price) ? `${elem.price}€` : t('Inclus')

  // TODO handle deadline for registration line = disabled if deadline is passed
  // Should we display a message to inform the user about deadline?
  const disabled =
    !elem.available ||
    registrationDetails?.existing_registration?.status === ParticipantStatus.Confirmed

  return (
    <Stack
      direction="row"
      alignItems="center"
      margin={!disabled && elem.option.registration_information ? '0.5rem 0' : undefined}
    >
      <FormControlLabel
        disabled={disabled}
        key={elem.option.id}
        defaultChecked={!!elem.registered}
        control={
          <Checkbox
            defaultChecked={!!elem.registered}
            onChange={(_e, checked) => {
              setOptionsByType(path, String(checked), elem)
            }}
          />
        }
        label={
          <Stack>
            <Typography className="MuiFormControlLabel-label">{label}</Typography>
            {!disabled && elem.option.registration_information && (
              <FormHelperText sx={{ fontWeight: 600, fontSize: '0.9rem' }}>
                {elem.option.registration_information}
              </FormHelperText>
            )}
          </Stack>
        }
        sx={{ flex: '1 0' }}
      />
      <Stack flex={{ sm: '0.5 0', lg: '0.8 0' }}>
        {hideFreePrice && !Number(elem.price) ? null : (
          <Typography className="MuiFormControlLabel-label" fontWeight="bold">
            {price}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
